import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { projectLocationsKeys } from '../locationsKeys'
import { RequestTypes } from '../requestTypes'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useSetProjectLocationBoundary = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['setProjectLocationBoundary']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...projectLocationsKeys.setProjectLocationBoundary,
    ...options,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: projectLocationsKeys._def })
      options?.onSuccess?.(...args)
    },
  })
}
